import * as React from 'react';
import * as classNames from 'classnames';
import AboutDirectCheckoutBullets from './about_direct_checkout_bullets';
import { PaymentProvider } from './payment_provider';
import { reverbPaymentsImageStyleClass } from './reverb_payments_image';

interface Props {
  sellingFeePercent: number;
  shopCurrency: string;
  bankCountryCode: string;
  showRadioButton?: boolean;
  selected?: boolean;
  inputName: string;
  onSelectReverbPayments?(paymentProvider: string): void;
  children?: JSX.Element;
}

export default function ReverbPaymentsInput(props: Props) {
  function radioClassName() {
    if (props.showRadioButton) {
      return '';
    }

    return 'payment-setup__label--non-radio';
  }

  function inputField() {
    if (props.showRadioButton) {
      return (
        <input
          type="radio"
          value="direct_checkout"
          checked={props.selected}
          name={props.inputName}
          onChange={() => props.onSelectReverbPayments(PaymentProvider.ReverbPayments)}
          id="shop-settings-dc-radio"
        />
      );
    }

    return (
      <input type="hidden" name={props.inputName} value="direct_checkout" />
    );
  }

  return (
    <div className="payment-setup">
      <div className={classNames('payment-setup__label payment-setup__label--dc scaling-mt-2', radioClassName())}>
        {inputField()}
        <label htmlFor="shop-settings-dc-radio">
          <div className={classNames('payment-setup__provider-logo', reverbPaymentsImageStyleClass(props))} />
        </label>
      </div>
      <div className="payment-setup__info">
        <AboutDirectCheckoutBullets
          sellingFeePercent={props.sellingFeePercent}
          shopCurrency={props.shopCurrency}
        />
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/reverb_payments_input.tsx